import Http from '../../utils/Http';
import { Dispatch, AnyAction } from 'redux';
import * as Subscriber from '../../store/allStates/signIn/actions';
import * as userAuthenticationActions from '../../store/allStates/userAuthentication/actions';
import Transformer from '../../utils/Transformer';
import { admin_prefix } from '../../../configs/constant';

export function AdminLogin(requestdata: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise(async (resolve, reject) => {
            Http.post(`${admin_prefix}auth/login`, requestdata)
                .then((res) => {
                    const data = Transformer.fetch(res.data.jwtToken);
                    dispatch(Subscriber.signIn(data));
                    return resolve(res.data);
                })
                .catch((err) => {
                    if (err.response) {
                        const statusCode = err.response.status;
                        const data = {
                            error: null,
                            statusCode,
                        };
                        data.error = err.response.data;
                        return reject(data);
                    }
                });
        });
}

export function AdminChangePassword(requestdata: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}auth/change-password`, requestdata)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function AdminForgotPassword(requestdata: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}auth/forgot-password`, requestdata)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function AdminResendVerification(requestdata: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}auth/resend-verification`, requestdata)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function checkActivationHash(email: any, userToken: any, username: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}auth/check-activation?email=${email}&token=${userToken}&userName=${username}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function AdminResetPassword(requestdata: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}auth/reset-password`, requestdata)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export const authCheck = () => {
    return (dispatch: Dispatch<AnyAction>) => {
        const check_org_token = localStorage.getItem('adminToken');
        if (check_org_token) {
            dispatch(userAuthenticationActions.changeAuthFlag(true, check_org_token));
        } else {
            dispatch(userAuthenticationActions.changeAuthFlag(false, ''));
        }
    };
};

export function AdminLogout() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}auth/logout`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    dispatch(userAuthenticationActions.authLogout());
                    delete Http.defaults.headers.authrization;
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function GetUserProfile() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}auth/adminuser`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function verifyUserEmail(email: any, userToken: any, username: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}auth/verify-activation?email=${email}&token=${userToken}&userName=${username}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function GetDashboardCount() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}auth/dashboard`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getcompanyprofile() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}auth/view-company-info`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function userEdit(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.put(`${admin_prefix}auth/edit-profile`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getsmtpsettings() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}settings/smtp-settings`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function smtpSettingsEdit(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.put(`${admin_prefix}settings/edit-smtp-settings`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getwebservicesettings() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}settings/web-service-settings`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function webServiceSettingsEdit(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.put(`${admin_prefix}settings/edit-web-service-settings`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function verifyUserNewEmailRequest(email: any, userToken: any, username: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(
                `${admin_prefix}auth/acknowledge-activation?email=${email}&token=${userToken}&userName=${username}`,
            )
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function barnchList() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}meta-branch/meta-branch-dropdown`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function getGstSettings() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}settings/get-gst-settings`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function editGstSettings(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.put(`${admin_prefix}settings/edit-gst-settings`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function ResendDocumentMailAPI(email: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}auth/resend-document/${email}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function ResendCreditOnHoldMailAPI(email: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}auth/resend-credit-on-hold/${email}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function SendMailToBuyerUpdateCredentials(id: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}auth/update-username-password-mail/${id}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function updateBuyerCredentials(requestdata: any, token: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.put(`${admin_prefix}auth/update-buyer-credentials/${token}`, requestdata)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}
